import style from "./loader.module.scss"

export default function InlineLoader({ text = '', className = '', themeType="dark" }) {
  return (
    <div className={`${style.InlineLoader} ${className}`} theme-type={themeType}>
      <div className="lds-dual-ring"></div> <span className={style.Text}>{text}</span>
    </div>
  )
}